<!-- prettier-ignore -->

<div class="add-pdf-container">
    <h1>{{ "Info sobre la ciudad o PDFs" | translate }}</h1>
  
    @for (category of categories(); track category) {
        <div class="categories-wrapper">
            <h3>{{ category?.name?.[translate.currentLang] }}</h3>
            <div scrollControl #scrollDirective="scrollDirective" class="cardsScrollContainer cards-scroll-container-pdf">
                <span class="goLeftCardsScrollContainerPdf eventGoLeft go-left-pdf" scrollControl> < </span>
                <span class="goRightCardsScrollContainerPdf eventGoRight go-right-pdf" scrollControl> > </span>
                <div class="pdf-cards-wrapper eventContainer" scrollControl>
                    @for (pdf of category.pdfs; track pdf) {
                        <div class="select-pdfs">
                            <cicerone-generic-card [item]="pdf" [isPdfCheckbox]="true" [isSelected]="isSelected(pdf.id)" (pdfEmitter)="togglePdf($event)"></cicerone-generic-card>
                        </div>
                    }
                </div>
            </div>
    
            @for (subcategory of category.subcategories; track subcategory) {
                <div class="categories-wrapper subcategories">
                    <h5>{{ subcategory?.name?.[translate.currentLang] }}</h5>
                    <div class="cardsScrollContainer cards-scroll-container-pdf">
                        <span class="goLeftCardsScrollContainerPdf eventGoLeft go-left-pdf" scrollControl> < </span>
                        <span class="goRightCardsScrollContainerPdf eventGoRight go-right-pdf" scrollControl> > </span>
                        <div class="pdf-cards-wrapper eventContainer" scrollControl>
                            @for (pdf of subcategory.pdfs; track pdf) {
                                <div class="select-pdfs">
                                    <cicerone-generic-card [item]="pdf" [isPdfCheckbox]="true" [isSelected]="isSelected(pdf.id)" (pdfEmitter)="togglePdf($event)"></cicerone-generic-card>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            <hr style="height: 0;  border: 1px #999 dashed; width: 100%; margin-top: 25px;">
    
        </div>
    }

    @if(showBackButton()){
        <div class="add-pdf-container__button-container">
            <button (click)="toggleView()">{{'Volver' | translate}}</button>
        </div>
    }
    
</div>